import { Button } from '@change/ds-core-ui';
import { LockOutlineIcon } from '@change/ds-icons';

import { useSubmitButton } from './hooks/useSubmitButton';

type Props = {
	disabled: boolean;
	loading: boolean;
	onClick?: () => void;
};

export function SubmitButton({ disabled, loading, onClick }: Props): JSX.Element {
	const { label } = useSubmitButton({ loading });
	return (
		<div sx={{ width: '100%' }}>
			<Button
				variant="primary"
				type="submit"
				className="w-full"
				disabled={disabled || loading}
				data-qa="promote-submit-button"
				onClick={onClick}
				leadingIcon={<LockOutlineIcon size="x-small" />}
			>
				{label}
			</Button>
		</div>
	);
}
